import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { isEmpty, isEqual } from "lodash-es";
import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { Game } from "../../game/game.model";
import { GameSelector } from "../../game/game.selector";
import { mapGames } from "../../game/game.util";
import { GamingExternalState } from "../../state";

import { RECOMMENDED_GAMES_ACTION_TYPE } from "./recommended-games.action";

@Injectable({
	providedIn: "root",
})
export class RecommendedGamesSelector {
	constructor(private gameSelector: GameSelector) {}

	getAll() {
		return (state: GamingExternalState): Game[] => {
			const gameIds = state.gamingExternal.recommendedGames.games;

			if (isEmpty(gameIds)) {
				return [];
			}

			return mapGames(gameIds, this.gameSelector.getAll()(state));
		};
	}

	getAll$() {
		return (state$: Observable<GamingExternalState>): Observable<Game[]> =>
			state$.pipe(
				distinctUntilChanged(isEqual, (state) => [
					state.gamingExternal.recommendedGames.games,
					this.gameSelector.getAll()(state),
				]),
				map(this.getAll())
			);
	}

	isBusy() {
		return (state: GamingExternalState): boolean =>
			FetchStatusSelector.isBusy(RECOMMENDED_GAMES_ACTION_TYPE.getAll)(state);
	}
}
